// Terminal color utilities for console logging
export const terminalColors = {
  // Status colors
  info: (text: string) => `\x1b[36m${text}\x1b[0m`,      // Cyan
  success: (text: string) => `\x1b[32m${text}\x1b[0m`,   // Green  
  warning: (text: string) => `\x1b[33m${text}\x1b[0m`,   // Yellow
  error: (text: string) => `\x1b[31m${text}\x1b[0m`,     // Red
  
  // Emphasis colors
  bold: (text: string) => `\x1b[1m${text}\x1b[0m`,       // Bold
  dim: (text: string) => `\x1b[2m${text}\x1b[0m`,        // Dim
  highlight: (text: string) => `\x1b[7m${text}\x1b[0m`,  // Reverse
  
  // Custom colors
  blue: (text: string) => `\x1b[34m${text}\x1b[0m`,      // Blue
  magenta: (text: string) => `\x1b[35m${text}\x1b[0m`,   // Magenta
  gray: (text: string) => `\x1b[90m${text}\x1b[0m`,      // Gray
}; 